<template>
    <swiper class="home-banner" :options="swiperOption">
        <swiper-slide v-for="slide in slides" :key="slide.id">
            <section class="section--banner" v-lazy:background-image.container="{
                    src: env.imageUrl + slide.image,
                    loading: env.imageUrl + slide.thumb_image,
                }">
                <div class="motor-banner">
                    <h1>{{slide.header}}</h1>
                    <p>{{slide.sub_header}}</p>
                </div>
            </section>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { env } from '../enviorments'

export default {
    name: 'home-banner',
    props: {
        slides: Array,
    },
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            env,
            swiperOption: {
                autoHeight: true,
                spaceBetween: 10,
                pagination: {
                    el: '.swiper-pagination'
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
        }
    }
}
</script>

<style lang="scss" scoped>
.home-banner {
    width: 100%;
    .section--banner {
        width: 100%;
        height: 800px;
        max-height: 100vh;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        padding-top: var(--header-height);
        .motor-banner {
            width: 100%;
            max-width: 1500px;
            padding: 40px 10px;
            text-align: center;
            font-size: 2rem;
            background-image: linear-gradient(to right, #2e79bcdd, #2e79bcdd);
            @media (min-width: 576px) {
                font-size: 2rem;
            }
            @media (min-width: 768px) {
                font-size: 2.5rem;
                background-image: linear-gradient(to right, #2e79bc00, #2e79bcee, #2e79bcee, #2e79bc00);
            }
            @media (min-width: 992px) {
                font-size: 3rem;
            }
            h1, p {
                margin: 0;
                padding: 5px;
                font-weight: 900;
                color: #fff;
                text-transform: uppercase;
                text-shadow: 0 2px 2px #333;
            }
            h1 {
                font-size: 1.5em;
                line-height: 1.2em;
            }
            p {
                font-size: 1em;
                line-height: 1em;
            }
        }
    }
}
</style>